import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Dashboard: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      // Redirigir según el rol a la ruta específica
      switch (user.role_name) {
        case 'super_admin':
        case 'admin':
          navigate('/admin/dashboard', { replace: true });
          break;
        case 'mentor':
          navigate('/mentor/dashboard', { replace: true });
          break;
        case 'mentee':
          navigate('/mentee/dashboard', { replace: true });
          break;
        default:
          console.error('Rol no reconocido:', user.role_name);
      }
    }
  }, [user, navigate]);

  if (!user) {
    return null;
  }

  // Mostrar loading mientras redirige
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-secondary-600">Redirigiendo...</p>
      </div>
    </div>
  );
};

export default Dashboard;